import {makeStyles} from "@material-ui/styles";
import {createStyles, Theme} from "@material-ui/core";

export const usePatientsListPriorityStatusSelectorStyle = makeStyles((theme: Theme) => createStyles({
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '12px',
    },
    control: {
        minWidth: '200px',
    },
}));
